import React, { useEffect, useState } from "react";
import "./CommentItem.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import ReplyItem from "../ReplyItem/ReplyItem";
import { useDispatch, useSelector } from "react-redux";
import { addReplyId } from "../../../Redux/CommentSlice";

function CommentItem({ treeData, isReply = false, isOwn = false }) {
  const [replyInput, setReplyInput] = useState({
    open: false,
    input: "",
    replyId: null,
  });
  const dispatch = useDispatch();
  const showReplyIds = useSelector((state) => state.comment.replyIds);

  const handleShowReply = (commentId) => {
    if (!showReplyIds.includes(commentId)) {
      dispatch(addReplyId(commentId));
    }
  };

  return (
    <div className="commentTreeItem">
      {treeData.map((treeNode) => (
        <React.Fragment key={treeNode.id}>
          <div className="commentItem">
            <img
              className={`cmtAvatar ${isReply && "cmtReplyAvatar"}`}
              src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8YXJ0aXN0fGVufDB8fDB8fA%3D%3D&w=1000&q=80"
            />
            <div className="commentItemWrapper">
              <div className="commmentContent">
                <span className="commentUsername">John Wick</span>
                <span>{treeNode.title}</span>
              </div>
              <div className="commentFuntional">
                <div className="commentFuntionalInfo">
                  <span>8 giờ</span>
                  <span>Thích</span>
                  <span
                    onClick={() =>
                      setReplyInput((prev) => ({
                        ...prev,
                        open: !prev.open,
                        replyId: treeNode.id,
                      }))
                    }
                  >
                    Phản hồi
                  </span>
                  {isOwn && <span>Xóa</span>}
                </div>
                <div className="commentInfo">
                  <span>
                    {20} <FontAwesomeIcon color="red" icon={faHeart} />
                  </span>
                </div>
              </div>
              {!showReplyIds.includes(treeNode.id) &&
                treeNode?.replys.length > 0 && (
                  <div className="showReplyBtn">
                    <span onClick={() => handleShowReply(treeNode.id)}>
                      Xem tất cả {1} phản hồi
                    </span>
                  </div>
                )}
              {replyInput.open && replyInput.replyId === treeNode.id && (
                <ReplyItem isReplyCmt={true} />
              )}
            </div>
          </div>
          {showReplyIds.includes(treeNode.id) && (
            <div className="commentReplyTree">
              {treeNode?.replys?.map((childNode) => (
                <CommentItem
                  key={childNode.id}
                  treeData={[childNode]}
                  isReply={true}
                  isOwn
                />
              ))}
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default CommentItem;
